// API Configuration
export const API_BASE_URL = 'https://app.zavarka39.ru/api';
export const API_ADMIN_URL = `${API_BASE_URL}/v1/admin`;

// Token storage key
export const ACCESS_TOKEN_KEY = 'admin_token';

// WebSocket Configuration
export const CHAT_API_BASE_URL = 'https://chat.zavarka39.ru/api';
export const WS_CHAT_URL = 'wss://chat.zavarka39.ru/ws/chat';
